<template>
  <div class="website-directory">
    <div class="wd-container">
      <h1 class="wd-title">供应链网站大全</h1>
      <span class="wd-desc">供应链风控与外贸业务常用官方平台导航</span>

      <div class="filter-bar">
        <div class="filter-row">
          <el-input v-model="keyword" placeholder="搜索平台名称 / 说明" size="small" class="search-input" clearable @keyup.enter.native="handleSearch"></el-input>
          <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
          <el-button size="small" @click="handleReset">重置</el-button>
        </div>
        <div class="filter-row tag-filter-row">
          <span class="filter-label">标签：</span>
          <div class="tag-list">
            <span v-for="item in options['SUPPLY_CHAIN_URL_TAG']" :key="item.value"
                  :class="['tag-item', { active: tagFilter.indexOf(item.label) > -1 }]"
                  @click="toggleTagFilter(item.label)">{{ item.label }}</span>
          </div>
        </div>
        <div class="filter-row tag-filter-row">
          <span class="filter-label">类型：</span>
          <div class="tag-list">
            <span v-for="item in options['SUPPLY_CHAIN_URL_PLATFORM']" :key="item.value"
                  :class="['tag-item', { active: typeFilter.indexOf(item.label) > -1 }]"
                  @click="toggleTypeFilter(item.label)">{{ item.label }}</span>
          </div>
        </div>
      </div>

      <div class="table-wrap">
        <!-- 页签切换 -->
        <div class="tab-bar">
          <div :class="['tab-item', { active: activeTab === 'all' }]" @click="switchTab('all')">全部网站</div>
          <div :class="['tab-item', { active: activeTab === 'fav' }]" @click="switchTab('fav')">我的收藏</div>
        </div>

        <el-table :data="currentRows" v-loading="loading || favLoading" border style="width: 100%"
                  :empty-text="(activeTab === 'fav' && !isLoggedIn) ? '登录后可查看我的收藏' : '暂无数据'">
          <el-table-column label="#" width="55" align="center">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="平台名称" min-width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <i v-if="scope.row.isImportant" class="el-icon-star-on" style="color: #ff6b35; margin-left: 6px;"></i>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="siteUrl" label="网址" min-width="200">
            <template slot-scope="scope">
              <a :href="scope.row.siteUrl" target="_blank" rel="noopener" class="site-link">{{ scope.row.siteUrl }}</a>
            </template>
          </el-table-column> -->
          <el-table-column label="标签分类" min-width="120">
            <template slot-scope="scope">
              <template v-if="scope.row.tagList && scope.row.tagList.length">
                <el-tag v-for="(tag, i) in scope.row.tagList" :key="i" size="mini" :type="scope.row.isImportant ? 'danger' : ''" style="margin-right: 4px;">{{ tag }}</el-tag>
              </template>
              <span v-else style="color: #999;">—</span>
            </template>
          </el-table-column>
          <el-table-column label="网站类型" min-width="80">
            <template slot-scope="scope">
              <el-tag size="mini">{{ scope.row.siteType }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="说明" min-width="280">
            <template slot-scope="scope">
              <span v-if="scope.row.isImportant" style="font-weight: bold;">{{ scope.row.description }}</span>
              <span v-else>{{ scope.row.description }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="210" fixed="right" align="left">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="visitItem(scope.row)">访问</el-button>
              <el-button type="text" size="small" @click="copyUrl(scope.row)">复制</el-button>
              <el-button type="text" size="small"
                         :style="{ color: scope.row.fav ? '#f56c6c' : '#409eff' }"
                         @click="handleToggleFav(scope.row)">{{ scope.row.fav ? '取消收藏' : '收藏' }}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            v-if="activeTab === 'all'"
            background
            style="float: right;margin-top: 10px"
            layout="prev, pager, next"
            :total="total"
            :current-page="currentPage"
            :page-size="pageSize"
            @size-change="sizeChange"
            @current-change="currentChange">
          </el-pagination>

      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentUser } from '@/utils/auth'

export default {
  name: 'websiteDirectory',
  components: {
  },
  data () {
    return {
      options: {},
      keyword: '',
      tagFilter: [],
      typeFilter: [],
      tableData: [],
      favRecords: [],
      isLoggedIn: false,
      activeTab: 'all',
      loading: false,
      favLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {
    // 收藏状态映射：siteId -> 收藏记录id
    favMap () {
      const map = {}
      this.favRecords.forEach(fav => {
        const site = fav.supplyChainSite || {}
        const siteId = site.id != null ? site.id : fav.targetId
        if (siteId != null) map[String(siteId)] = fav.id
      })
      return map
    },
    // 收藏页签展示数据（已收藏网址）
    favRows () {
      return this.favRecords.map(fav => {
        const site = fav.supplyChainSite || {}
        const siteId = site.id != null ? site.id : fav.targetId
        return {
          id: siteId,
          name: site.name || fav.targetTitle || '',
          siteUrl: site.siteUrl || fav.targetUrl || '',
          siteType: this.normalizeSiteType(site.siteType),
          tagList: site.tagList || (site.tags ? site.tags.split(',').filter(t => t) : []),
          description: site.description || fav.targetSubtitle || '',
          isImportant: !!site.isImportant,
          fav: true,
          favId: fav.id
        }
      })
    },
    // 收藏页签本地过滤
    filteredFavRows () {
      let rows = this.favRows
      if (this.keyword) {
        const k = this.keyword.toLowerCase()
        rows = rows.filter(r =>
          ((r.name || '') + (r.description || '') + (r.siteUrl || '')).toLowerCase().indexOf(k) > -1
        )
      }
      if (this.tagFilter.length) {
        rows = rows.filter(r => (r.tagList || []).some(tag => this.tagFilter.indexOf(tag) > -1))
      }
      if (this.typeFilter.length) {
        rows = rows.filter(r => this.typeFilter.indexOf(r.siteType) > -1)
      }
      return rows
    },
    // 当前页签展示数据
    currentRows () {
      if (this.activeTab === 'fav') {
        return this.filteredFavRows
      }
      return this.tableData.map(row => {
        const favId = this.favMap[String(row.id)]
        return { ...row, fav: !!favId, favId: favId || null }
      })
    }
  },
  created () {
    this.$bus.$on('login-success', this.handleLoginSuccess)
  },
  mounted () {
    this.isLoggedIn = !!getCurrentUser()
    this.getListData()
    this.getByTypes()
    if (this.isLoggedIn) {
      this.loadFavorites()
    }
  },
  beforeDestroy () {
    this.$bus.$off('login-success', this.handleLoginSuccess)
  },
  methods: {
    getListData () {
      this.loading = true
      let params = {
        isPage: true,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        data: {},
        params: {}
      }
      if (this.keyword) {
        params.params['$OR'] = {
          name$LIKE: this.keyword,
          description$LIKE: this.keyword
        }
      }
      if (this.tagFilter.length) {
        params.data.tags = this.tagFilter.join(',')
      }
      if (this.typeFilter.length) {
        params.data.siteType = this.typeFilter.join(',')
      }
      this.$http({
        url: this.$http.adornUrl('/crmapi/crm/supplyChainSite/list'),
        method: 'post',
        data: this.$http.adornData(params)
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          let result = data.result || {}
          this.tableData = result.list || []
          this.total = result.total || 0
        } else {
          this.$message.error(data.message || '请求失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getByTypes () {
      this.$http({
        url: this.$http.adornUrl('/crmapi/sys/dictData/getByTypes'),
        method: 'get',
        params: {
          typeNumbers: 'SUPPLY_CHAIN_URL_PLATFORM,SUPPLY_CHAIN_URL_TAG'
        }
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.options = data.result
        }
      })
    },
    // 查询当前登录用户的收藏列表（SUPPLY_CHAIN_SITE）
    loadFavorites () {
      if (!this.isLoggedIn) {
        this.favRecords = []
        return
      }
      this.favLoading = true
      this.$http({
        url: this.$http.adornUrl('/crmapi/crm/favorite/list'),
        method: 'post',
        data: this.$http.adornData({
          data: { source: 'SUPPLY_CHAIN_SITE' },
          params: {}
        })
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          const result = data.result || {}
          this.favRecords = result.list || []
        } else {
          this.$message.error((data && data.message) || '获取收藏列表失败')
        }
      }).finally(() => {
        this.favLoading = false
      })
    },
    // 网站类型编码转展示标签
    normalizeSiteType (val) {
      if (!val) return ''
      const opts = this.options['SUPPLY_CHAIN_URL_PLATFORM'] || []
      const found = opts.find(o => String(o.value) === String(val))
      return found ? found.label : val
    },
    handleLoginSuccess () {
      this.isLoggedIn = !!getCurrentUser()
      if (this.isLoggedIn) {
        this.loadFavorites()
      }
    },
    switchTab (tab) {
      this.activeTab = tab
      if (tab === 'fav') {
        if (!this.isLoggedIn) {
          this.$bus.$emit('open-login')
        } else {
          this.loadFavorites()
        }
      }
    },
    handleToggleFav (row) {
      if (row.fav) {
        this.removeFavorite(row)
      } else {
        this.addFavorite(row)
      }
    },
    addFavorite (row) {
      if (!this.isLoggedIn) {
        this.$bus.$emit('open-login')
        return
      }
      this.$http({
        url: this.$http.adornUrl('/crmapi/crm/favorite/add'),
        method: 'post',
        data: this.$http.adornData({
          source: 'SUPPLY_CHAIN_SITE',
          targetId: row.id
        })
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.$message.success('收藏成功')
          this.loadFavorites()
        } else {
          this.$message.error((data && data.message) || '收藏失败')
        }
      })
    },
    removeFavorite (row) {
      const favId = row.favId
      if (!favId) return
      this.$http({
        url: this.$http.adornUrl('/crmapi/crm/favorite/del'),
        method: 'post',
        data: this.$http.adornData({ id: favId })
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.$message.success('已取消收藏')
          this.loadFavorites()
        } else {
          this.$message.error((data && data.message) || '取消收藏失败')
        }
      })
    },
    handleSearch () {
      this.currentPage = 1
      this.getListData()
    },
    handleReset () {
      this.keyword = ''
      this.tagFilter = []
      this.typeFilter = []
      this.currentPage = 1
      this.getListData()
    },
    toggleTagFilter (item) {
      const index = this.tagFilter.indexOf(item)
      if (index > -1) {
        this.tagFilter.splice(index, 1)
      } else {
        this.tagFilter.push(item)
      }
      this.currentPage = 1
      this.getListData()
    },
    toggleTypeFilter (item) {
      const index = this.typeFilter.indexOf(item)
      if (index > -1) {
        this.typeFilter.splice(index, 1)
      } else {
        this.typeFilter.push(item)
      }
      this.currentPage = 1
      this.getListData()
    },
    visitItem (row) {
      if (row.siteUrl) window.open(row.siteUrl, '_blank')
    },
    copyUrl (row) {
      if (!row.siteUrl) return
      if (navigator.clipboard) {
        navigator.clipboard.writeText(row.siteUrl).then(() => {
          this.$message.success('网址已复制：' + row.siteUrl)
        })
      } else {
        this.$message.info('网址：' + row.siteUrl)
      }
    },
    sizeChange (size) {
      this.pageSize = size
      this.getListData()
    },
    currentChange (currPage) {
      this.currentPage = currPage
      this.getListData()
    }
  }
}
</script>

<style lang="scss" scoped>
.website-directory {
  padding: 90px 0 40px;
  background: #f5f7fa;
  min-height: 100vh;

  .wd-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .wd-title {
    font-size: 28px;
    font-weight: 600;
    color: #1f2329;
    margin: 0 0 8px;
  }

  .wd-desc {
    color: #8f959e;
    font-size: 14px;
    display: block;
    margin-bottom: 24px;
  }

  .filter-bar {
    background: #fff;
    padding: 16px 20px;
    border-radius: 8px;
    margin-bottom: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    border: 1px solid #e8e9eb;

    .filter-row {
      display: flex;
      align-items: center;
      gap: 12px;

      & + .filter-row {
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid #f0f0f0;
      }
    }

    .search-input {
      width: 300px;
    }

    .tag-filter-row {
      flex-wrap: wrap;
    }

    .filter-label {
      font-size: 13px;
      color: #606266;
      white-space: nowrap;
    }

    .tag-list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .tag-item {
      display: inline-block;
      padding: 4px 12px;
      font-size: 13px;
      color: #606266;
      background: #f5f7fa;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        color: #409eff;
        border-color: #c6e2ff;
        background: #ecf5ff;
      }

      &.active {
        color: #fff;
        background: #409eff;
        border-color: #409eff;
      }
    }

    .tag-empty {
      font-size: 13px;
      color: #c0c4cc;
    }
  }

  .tab-bar {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
    background: #fff;
    padding: 8px 12px;
    // border-radius: 8px;
    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    // border-bottom: 1px solid #e8e9eb;

    .tab-item {
      padding: 8px 24px;
      font-size: 14px;
      color: #606266;
      cursor: pointer;
      // border-radius: 4px;
      transition: all 0.2s;

      &:hover {
        color: #409eff;
        background: #ecf5ff;
      }

      &.active {
        color: #409eff;
        font-weight: bold;
        // background: #409eff;
        border-bottom: 3px solid #409eff;
      }
    }
  }

  .table-wrap {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    border: 1px solid #e8e9eb;
    overflow: hidden;
  }

  .site-link {
    color: #47a5f8;
    text-decoration: none;
    font-size: 12px;
    word-break: break-all;
    line-height: 1.5;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/websiteDirectory.vue